module.exports = __webpack_public_path__ + "img/illustration-signUp.748df92e.svg";